import { just, Maybe, nothing } from 'maybeasy';
import { ProgramBase, ProgramProductDetails } from '../../../ProgramStore/Types';

export const whenProgramProductDetails = (program: ProgramBase): Maybe<ProgramProductDetails> =>
  program.productDetails.andThen(({ payload }) => {
    switch (payload.kind) {
      case 'program':
        return just(payload);
      case 'coaching':
      case 'program-sequence':
      case 'group-coaching':
        return nothing();
    }
  });
